import { AppConfig } from './app-config.token';

export const runtimeConfig: AppConfig = {
  appName: 'venta-planes-cotizacion-web',
  apiBaseUrl: 'https://dummyjson.com',
  environment: (import.meta.env['VITE_ENV'] ?? 'dev') as AppConfig['environment'],
  enableI18n: false,
  announcementBanner: '',
  auth: {
    // Replaced by scaffolder with project slug — acts as a namespaced sessionStorage key
    tokenStorageKey: 'venta-planes-cotizacion-web',
    authHeader: 'Authorization',
    gatewayLoginUrl: '',
    tokenExchangeUrl: '',
  },
};
